<h3>Export Summary</h3>
<p>
    Export the "{{ processMap.name }}" task map to {{ exportDestination }}
    @if (board) {
        <span>"{{ board.name }}"</span>
    }
</p>

<h3>Role Allocations</h3>
@if (!rolePersonAllocations.roles || rolePersonAllocations.roles.length < 1) {
    <div>No applicable roles</div>
} @else {
    @for (role of rolePersonAllocations?.roles; track role) {
        <div class="row mb-1">
            <div class="col-12 col-md-4">{{ role.label }}:</div>
            <div class="col-12 col-md-8">
                {{ rolePersonAllocations[role.roleId]?.fullName || "Unallocated" }}
            </div>
        </div>
    }
}

@if (prefix) {
    <h3 class="mt-3">Prefix</h3>
    <p>
        You elected to use "<b>{{ prefix }}</b>" as the prefix for the exported items
    </p>
}

<br />
@if (!started) {
    <p><b>To continue, press the export button below.</b></p>
}
@if (started && progressTotalCount > 0) {
    <div>
        <dx-progress-bar width="100%"
                         [min]="0"
                         [max]="progressTotalCount"
                         [value]="progressCurrentCount"
                         [showStatus]="true"></dx-progress-bar>
    </div>
}
@if (completed) {
    <p>
        The "{{ processMap.name }}" task map has been exported to
        {{ exportDestination }}
        @if (!!board) {
            <adapt-link-team-kanban [team]="$any(board!.team)"
                                    [board]="board!"
                                    [buttonText]="board!.name"
                                    data-test="process-map-exported-team-link"></adapt-link-team-kanban>
        }
    </p>
}
